import React, { useCallback, useEffect, useState } from 'react';
import './get-started.css';
import { NavLink } from 'react-router-dom';
import { filterItems, getMenuItemsTop } from 'components/account/sidebar-v2/menu-item-util';
import { useGlobalState } from 'store/reducers/reducer';
const CloseButton = ({ onClick }) => (React.createElement("svg", { className: "tutorial-close", height: "35px", onClick: onClick, viewBox: "0 0 512 512", width: "35px" },
    React.createElement("circle", { cx: "256", cy: "256", fill: "#DDD", r: "256" }),
    React.createElement("line", { stroke: "black", strokeWidth: "25px", x1: "150", x2: "362", y1: "150", y2: "362" }),
    React.createElement("line", { stroke: "black", strokeWidth: "25px", x1: "150", x2: "362", y1: "362", y2: "150" })));
export const GetStarted = () => {
    const { state } = useGlobalState();
    const user = {
        ...state.user
    };
    const [tutorialPage, setTutorialPage] = useState(0);
    const [showTutorial, setShowTutorial] = useState(false);
    const topItems = filterItems(user, getMenuItemsTop(!!state.account?.hasAnalyticsAccess));
    const tutorialPages = topItems.map((item) => (React.createElement("div", { key: item.name },
        React.createElement("div", { className: "item-title" },
            item.icon,
            React.createElement("span", null, item.label)),
        React.createElement("p", { className: "item-description" }, item.description))));
    useEffect(() => {
        const vimeoScript = document.getElementById('vimeo');
        if (!vimeoScript) {
            const script = document.createElement('script');
            script.src = 'https://player.vimeo.com/api/player.js';
            script.id = 'vimeo';
            script.async = true;
            document.body.append(script);
        }
    }, []);
    const handleClose = useCallback(() => {
        setShowTutorial(false);
        setTutorialPage(0);
    }, []);
    return (React.createElement("div", null,
        React.createElement("h1", { className: "gs-h1" }, "Get Started"),
        React.createElement("div", { className: "gs-content" },
            React.createElement("h2", { className: "gs-header gs-h2" }, "Introduction"),
            React.createElement("p", { className: "intro-text" },
                "Vouched is an identity verification platform powered by artificial intelligence. It is completely automated and requires no extra human intervention for verifications. The process is simple. Using our tech, have your users take a picture of their ID and themselves, send them to us, and our backend will verify the authenticity of their identity. You can start verifying your users right now in the",
                ' ',
                React.createElement(NavLink, { to: "/account/candidates" }, "Candidates"),
                " page!"),
            React.createElement("div", { className: "video-container" },
                React.createElement("iframe", { allow: "autoplay; fullscreen; picture-in-picture", allowFullScreen: true, src: "https://player.vimeo.com/video/473354297?h=1326e115c7", style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 0
                    } })),
            React.createElement("h2", { className: "gs-header gs-h2" }, "Menu Items"),
            React.createElement("p", { className: "intro-text" },
                "Launch a quick tour of our menu items.",
                React.createElement("button", { className: "page-button page-button--tour", onClick: () => {
                        setShowTutorial(true);
                    }, type: "button" }, "Take a Tour")),
            showTutorial && (React.createElement("div", { className: "tutorial-overlay" },
                React.createElement("div", { className: "tutorial-overlay__content" },
                    React.createElement(CloseButton, { onClick: handleClose }),
                    tutorialPages[tutorialPage],
                    React.createElement("div", { className: "button-container" },
                        tutorialPage !== 0 && (React.createElement("button", { className: "page-button page-button--back", onClick: () => {
                                setTutorialPage((prevState) => prevState - 1);
                            }, type: "button" }, "Back")),
                        tutorialPage !== tutorialPages.length - 1 && (React.createElement("button", { className: "page-button page-button--next", onClick: () => {
                                setTutorialPage((prevState) => prevState + 1);
                            }, type: "button" }, "Next")))))),
            React.createElement("h2", { className: "gs-header gs-h2" }, "Integrations"),
            React.createElement("p", { className: "intro-text" },
                "Need to integrate Vouched into your custom application? Whether your app is desktop, web, or mobile, Vouched offers many solutions for seamless integration. With your new account, you are already halfway there!",
                ' ',
                React.createElement("b", null,
                    "Generate your Public and Private API keys on the",
                    ' ',
                    React.createElement(NavLink, { to: "/account/key" }, "Keys"),
                    " page"),
                ' ',
                "and follow one of our integration guides to start verifying your users' identities. You can also read our",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/docs", rel: "noreferrer", target: "_blank" }, "docs"),
                ' ',
                "for further information."),
            React.createElement("h3", { className: "gs-header gs-h3" }, "JS Plugin"),
            React.createElement("p", { className: "intro-text" },
                "Our Javascript (JS) Plugin is the recommended way to integrate Vouched. You will need a Public API Key for this method. Our",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/docs/js-plugin-wizard", rel: "noreferrer", target: "_blank" }, "JS Plugin Wizard"),
                ' ',
                "is an easy way to quickly create your plugin file with your key. Follow the steps and we will generate the code for you! Advanced users can take a look at more customizable starter code",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/docs/js-plugin", rel: "noreferrer", target: "_blank" }, "here"),
                "."),
            React.createElement("h3", { className: "gs-header gs-h3" }, "Mobile Webview"),
            React.createElement("p", { className: "intro-text" },
                "Vouched",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/docs/mobile-webview", rel: "noreferrer", target: "_blank" }, "Webview"),
                ' ',
                "allows you to integrate a view of your Vouched JS Plugin within your mobile application. This method supports iOS and Android."),
            React.createElement("h3", { className: "gs-header gs-h3" }, "Invite API"),
            React.createElement("p", { className: "intro-text" },
                "Send ID verification invites to your users through our",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/reference/sendinvites", rel: "noreferrer", target: "_blank" }, "API"),
                ". You will need a Private Key for this method."),
            React.createElement("h3", { className: "gs-header gs-h3" }, "API Responses"),
            React.createElement("p", { className: "intro-text" },
                "Our",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/reference/submitjob-1", rel: "noreferrer", target: "_blank" }, "API responses"),
                ' ',
                "contain the full result of a single verification process."),
            React.createElement("h3", { className: "gs-header gs-h3" }, "Other Integrations"),
            React.createElement("p", { className: "intro-text" },
                "For other customized integrations, please contact our support team at support@vouched.id and we will be happy to work with you on a solution. You can also read our",
                ' ',
                React.createElement("a", { href: "https://docs.vouched.id/docs", rel: "noreferrer", target: "_blank" }, "docs"),
                ' ',
                "for further information."),
            React.createElement("p", { className: "intro-text", style: { fontStyle: 'italic' } }, "Vouched is built with privacy in mind so you can protect your users' data. Vouched has SOC2 Type 1 certification as well as ISO/IEC-27001 and ISO/IEC 27701 certifications. Personal information is processed in compliance with California Consumer Privacy Act (CCPA) and General Data Protection Regulation (GDPR)."))));
};
